import {Exclude, Expose} from "class-transformer";
import {AbstractDictionaryApiModel} from "./abstract-dictionary.api-model";

@Exclude()
export class CityApiModel extends AbstractDictionaryApiModel {
  @Expose() public coordinates: number[];
}
